export { default as AgeBasedHero } from './AgeBasedHero';
